var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 11.5V0H3.5V11.5H2.5Z",
    fill: "#929FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64648 11.8536L0.646484 9.85359L1.35359 9.14648L3.00004 10.7929L4.64648 9.14648L5.35359 9.85359L3.35359 11.8536C3.15833 12.0489 2.84175 12.0489 2.64648 11.8536Z",
    fill: "#929FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1H6.5V0H10C10.1894 0 10.3625 0.107001 10.4472 0.276393C10.5319 0.445785 10.5136 0.648491 10.4 0.8L8 4H10.5V5H7C6.81062 5 6.63749 4.893 6.55279 4.72361C6.46809 4.55421 6.48637 4.35151 6.6 4.2L9 1Z",
    fill: "#929FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.5H7V9.5H10V10.5Z",
    fill: "#929FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94712 6.7764C8.86242 6.607 8.68932 6.5 8.49992 6.5C8.31052 6.5 8.13742 6.607 8.05272 6.7764L5.69092 11.5H6.80892L8.49992 8.11805L10.1909 11.5H11.3089L8.94712 6.7764Z",
    fill: "#929FAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescending);
export default __webpack_public_path__ + "static/media/sort-descending.5e071cceb2fd69507a73d826bdc1d185.svg";
export { ForwardRef as ReactComponent };